import { jwtDecode } from "jwt-decode";
import { createContext, type ReactNode, useContext, useState } from "react";

import { get } from "common/helpers/HTTP";
import { redirectToKeycloak } from "common/helpers/redirectToKeycloak";
import useWhitelabelCustomization from "common/hooks/useWhitelabelCustomization";

const AuthContext = createContext<{
  isAuthorized: boolean;
  logout: () => Promise<void>;
  checkToken: () => void;
}>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const { whitelabelCustomization } = useWhitelabelCustomization();
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);

  async function logout() {
    await get("oauth/logout");
    localStorage.removeItem("auth");

    if (whitelabelCustomization) {
      setIsAuthorized(false);
    } else {
      await redirectToKeycloak(false);
    }
  }
  function checkToken() {
    let isAuthSuccess = true;
    const token = localStorage.getItem("auth");

    if (token) {
      try {
        const { exp } = jwtDecode(token);
        const expirationTime = exp * 1000 - 60000;
        if (expirationTime && Date.now() >= expirationTime) {
          isAuthSuccess = false;
        }
      } catch (_error) {
        isAuthSuccess = false;
      }
    } else {
      isAuthSuccess = false;
    }

    if (!isAuthSuccess && !whitelabelCustomization) {
      redirectToKeycloak(true);
    } else {
      setIsAuthorized(isAuthSuccess);
    }
  }

  return (
    <AuthContext.Provider value={{ isAuthorized, logout, checkToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
